import { Schema, arrayOf } from 'normalizr';

const store = new Schema('stores');
const workroom = new Schema('workrooms');
const estimator = new Schema('estimators');

const surfaceType = new Schema('surface_types');
const helper = new Schema('helpers');
const crew = new Schema('crews');
const installer = new Schema('installers');
const pricePatch = new Schema('price_patches');
const payRate = new Schema('pay_rates');
const documentEntity = new Schema('documents');
const payRateUpload = new Schema('pay_rate_uploads');

const employee = new Schema('employees');

store.define({
  price_patch: pricePatch,
});

installer.define({
  helpers: arrayOf(helper),
  crews: arrayOf(crew),
});

crew.define({
  workrooms: arrayOf(workroom),
  surface_types: arrayOf(surfaceType),
});

estimator.define({
  stores: arrayOf(store),
  workrooms: arrayOf(workroom),
});

payRateUpload.define({
  user: employee,
});

const Schemas = {
  INSTALLER: installer,
  INSTALLER_ARRAY: arrayOf(installer),
  HELPER: helper,
  HELPER_ARRAY: arrayOf(helper),
  CREW: crew,
  CREW_ARRAY: arrayOf(crew),
  SURFACE_TYPE: surfaceType,
  SURFACE_TYPE_ARRAY: arrayOf(surfaceType),
  ESTIMATOR: estimator,
  ESTIMATOR_ARRAY: arrayOf(estimator),
  STORE: store,
  STORE_ARRAY: arrayOf(store),
  WORKROOM: workroom,
  WORKROOM_ARRAY: arrayOf(workroom),
  PRICE_PATCH: pricePatch,
  PRICE_PATCH_ARRAY: arrayOf(pricePatch),
  PAY_RATE: payRate,
  PAY_RATE_ARRAY: arrayOf(payRate),
  DOCUMENT: documentEntity,
  DOCUMENTS: arrayOf(documentEntity),
  PAY_RATE_UPLOAD: payRateUpload,
  PAY_RATE_UPLOAD_ARRAY: arrayOf(payRateUpload),
};

export default Schemas;



// WEBPACK FOOTER //
// ./client/app/shared/schemas/index.js